import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { DropdownIcon } from '../DropdownIcon/DropdownIcon';
import { Popper } from '../Popper/Popper';

/**
 * A `Popper` trigger for the `Dropdown` component.
 *
 * @extends Popper
 * @related [`Dropdown`, `Popper`]
 * @since 7.28.0
 */
var DropdownPopper = /*#__PURE__*/styled(Popper).withConfig({
  displayName: "DropdownPopper",
  componentId: "c11n-8-111-1__sc-u1wzgh-0"
})([""]);
DropdownPopper.displayName = 'DropdownPopper';
DropdownPopper.propTypes = {
  /**
   * The popper content, usually a `DropdownIcon` or a `DropdownButton`.
   */
  children: PropTypes.node,
  /**
   * The `Popper` `offset` prop.
   */
  offset: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  /**
   * Will close the dropdown when the trigger is no longer visible in the viewport.
   */
  shouldCloseOnViewportLeave: PropTypes.bool
};
DropdownPopper.defaultProps = {
  children: /*#__PURE__*/React.createElement(DropdownIcon, null),
  offset: [0, 8],
  shouldCloseOnViewportLeave: false
};

/** @component */
export { DropdownPopper };